var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestrictedSign = function SvgRestrictedSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "172px",
    height: "115px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "restricted-sign")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M89,109 L89,0 L83,0 L83,109 L78.0013869,109 C76.3430813,109 75,110.343146 75,112 L75,115 L97,115 L97,112 C97,110.346517 95.6562333,109 93.9986131,109 L89,109 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 22,
    height: 115,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 53,
    y: 12,
    width: 66,
    height: 52,
    rx: 3
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 66,
    height: 52,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "restricted-sign"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#DDDDDD",
    fillRule: "nonzero",
    points: "-1 115 172 115 172 114 -1 114"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    stroke: "#999999",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    strokeLinecap: "square",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-3",
    stroke: "#999999",
    mask: "url(#mask-4)",
    strokeWidth: 2,
    strokeLinecap: "square",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9643119,37.2354782 C94.9643119,35.4106993 94.428597,33.719849 93.5078369,32.2968563 L80.885054,44.9028981 C82.3247879,45.8403992 84.0323792,46.3928552 85.8571582,46.3928552 C90.8794856,46.3928552 94.9643119,42.2912878 94.9643119,37.2354782 Z M78.2399616,42.2410646 L90.8794856,29.6182817 C89.4397517,28.6472984 87.7154193,28.0948423 85.8571582,28.0948423 C80.8348308,28.0948423 76.7500045,32.1964097 76.7500045,37.2354782 C76.7500045,39.0937394 77.3024605,40.8013307 78.2399616,42.2410646 Z M98.7143164,37.2354782 C98.7143164,44.3671832 92.9553809,50.1428597 85.8571582,50.1428597 C78.7589354,50.1428597 73,44.3671832 73,37.2354782 C73,30.1205144 78.7589354,24.3448379 85.8571582,24.3448379 C92.9553809,24.3448379 98.7143164,30.1205144 98.7143164,37.2354782 Z",
    id: "\\uF05E",
    fill: "#D64456"
  })))));
};
export default SvgRestrictedSign;